export default "__VITE_ASSET__NX8pU3mb__"